/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-08 10:53:20
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-17 14:35:01
 */
import {
  ExpandOutlined,
  FullscreenExitOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons"
import { unwrapResult } from "@reduxjs/toolkit"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory } from "react-router-dom"
import useAnimateNumber from "use-animate-number"
import {
  BasicCharts,
  DataCard,
  DataTag,
  DonutPieCharts,
  LgBasicCharts,
  PieCharts,
  Select,
  Switch,
} from "vscreen/lib/index"
import { selectAppRegionCode } from "../../app/appSlice"
import { AppDispatch } from "../../app/store"
import { DataTable } from "../../components/DataTable/DataTable"
import { FlowchartTag } from "../../components/FlowchartTag/FlowchartTag"
import { Icon } from "../../components/icon/Icons"
import { LineCharts } from "../../components/LineCharts/LineCharts"
import { MapCharts } from "../../components/MapCharts/MapCharts"
import { Progress } from "../../components/Progress/Progress"
import { ProvinceTag } from "../../components/provinceTag/ProvinceTag"
import { TableSimple } from "../../components/TableSimple/DataTable"
import { DateTimeFormat } from "../../models/datetime"
import {
  ErrorDistributionValue,
  getFlagName,
  getStaticName,
  getStaticTitleName,
  getWarningRuleTitleName,
} from "../../models/Province"
import { transformNumber } from "../../models/transformNumber"
import {
  CountyRuleUseProps,
  ErrorDistributionParams,
  StaticDataProps,
} from "../../services/Province"
import { WarningRulesAnaylseParams } from "../../services/WarningRulesAnaylse"
import { useQuery, useWindowSize } from "../../utils/hooks"
import { getWarningRuleAnaylseData } from "../WarningRulesAnaylse/WarningRulesAnaylseSilce"
import "./Province.css"
import styles from "./Province.module.css"
import {
  getCityOverview,
  getCountyRuleData,
  getCountyRuleUseData,
  getErrorDistributionData,
  getOrganizationData,
  getProvinceMapAndAnaylseAndLastYaerData,
  getProvinceOverviewData,
  getStaticData,
  getWarningRuleData,
} from "./ProvinceSlice"

interface regionType {
  areaName: string[]
  cautionTotal: number
  doctorTotal: number
  handleTotal: number
  medicalTotal: number
  organizationTotal: number
  regionCode: string
  regionLevel: number
}

const filterData = [
  7114, 4707, 5802, 1719, 1496, 2832, 4332, 1805, 719, 3662, 1661,
]

export const Country = () => {
  const history = useHistory()

  const dispatch = useDispatch<AppDispatch>()

  const [FirstDate, setFirstDate] = useState<any>(null)

  const regionCode = useSelector(selectAppRegionCode)

  const [SecondDate, setSecondDate] = useState<ErrorDistributionParams>({}) // 诊疗行为异常分布请求参数

  const [stiatic, setStatic] = useState<StaticDataProps>({
    type: "ORGANIZATIONTYPE",
  }) // 监管占比

  const [WarningData, setWarningData] = useState<WarningRulesAnaylseParams>({
    dType: 2,
    text: "预警占比",
  }) // 预警占比

  const [IsFullscreen, setIsFullscreen] = useState<any>(undefined) // 全屏展示

  const isFullscreen = () => {
    return document.fullscreenElement || false
  }

  //数字动画配置
  const options = {
    duration: 200,
    enterance: false,
    direct: false,
    disabled: false,
    decimals: 0,
  }

  const [flagOptions, setFlagOptions] = useState([
    "机构类型",
    "监管机构",
    "监管医生",
    "诊疗行为",
  ])

  const [orgOp, setOrgOp] = useState<any>({ ...options }) //机构数
  const [docOp, setDocOp] = useState<any>({ ...options }) //医生数
  const [medOp, setMedOp] = useState<any>({ ...options }) //诊疗数
  const [errOp, setErrOp] = useState<any>({ ...options }) //预警数
  const [hadOp, setHadOp] = useState<any>({ ...options }) //执法数

  const [area, setArea] = useState("") // 地区名

  const [areaData, setAreaData] = useState<any>([]) // 地图数据

  const [Table, setTable] = useState<any>([]) // 监管数据总览

  const [ProgressData, setProgressData] = useState<ErrorDistributionValue[]>([]) // 异常行为数据分布

  const [TagData, setTagData] = useState<any>() // 中心展示数据

  // const [ScrollData, setScrollData] = useState<any>([]);

  const [HandleData, setHandleData] = useState<any>([]) // 折线图诊疗数量

  const [ErrorData, setErrorData] = useState<any>([]) // 折线图预警数

  const [FirstList, setFirstList] = useState<any>([]) // 监管占比饼图

  const [SecondList, setSecondList] = useState<any>([]) // 预警占比饼图

  const [timeData, setTimeData] = useState<any>([]) //处理时间

  const [countyTimeData, setCountTimeData] = useState<any>([]) //县平均处理时间

  const [GroudByList, setGroudByList] = useState<any>([]) // 接入机构占比饼图

  const [ruleUseData, setRuleUseData] = useState<any>([])

  const [ruleUser, setRuleUser] = useState<CountyRuleUseProps>({
    dType: 3,
  })

  const [cityPath, setCityPath] = useState<any>([])

  useEffect(() => {
    if (flagOptions) {
      setStatic({
        type: getFlagName(flagOptions[0]),
      })
    }
  }, [flagOptions])

  // 监管数据总览;
  useEffect(() => {
    setFlagOptions(["监管机构", "监管医生", "诊疗行为"])
    if (regionCode) {
      dispatch(getCityOverview({ scope: FirstDate, regionCode }))
        .then(unwrapResult)
        .then((record) => {
          setTable(record)
        })
    }
  }, [dispatch, FirstDate, regionCode])

  // 诊疗行为异常分布;
  useEffect(() => {
    if (regionCode) {
      dispatch(getErrorDistributionData({ ...SecondDate, regionCode, ps: 5 }))
        .then(unwrapResult)
        .then((record) => {
          setProgressData(record)
        })
    }
  }, [dispatch, SecondDate, regionCode])

  // 地图数据 + 折线图
  useEffect(() => {
    const key = 10000
    if (regionCode) {
      dispatch(getProvinceMapAndAnaylseAndLastYaerData(regionCode))
        .then(unwrapResult)
        .then((res) => {
          setCityPath(res.cityPathArr)
          setOrgOp({
            ...options,
            decimals: res.userAreaCountData.organizationTotal > key ? 2 : 0,
          })
          setDocOp({
            ...options,
            decimals: res.userAreaCountData.doctorTotal > key ? 2 : 0,
          })
          setMedOp({
            ...options,
            decimals: res.userAreaCountData.medicalTotal > key ? 2 : 0,
          })
          setErrOp({
            ...options,
            decimals: res.userAreaCountData.cautionTotal > key ? 2 : 0,
          })
          setHadOp({
            ...options,
            decimals: res.userAreaCountData.handleTotal > key ? 2 : 0,
          })

          setTagData(res.userAreaCountData)
          setOrganizationValue(
            transformNumber(res.userAreaCountData.organizationTotal)?.value,
            false
          )
          setDoctorValue(
            transformNumber(res.userAreaCountData.doctorTotal)?.value,
            false
          )
          setMedicalRecordValue(
            transformNumber(res.userAreaCountData.medicalTotal)?.value,
            false
          )
          setCautionValue(
            transformNumber(res.userAreaCountData.cautionTotal)?.value,
            false
          )
          setDisposeValue(
            transformNumber(res.userAreaCountData.handleTotal)?.value,
            false
          )
          setHandleData(
            res.latestYearSupervise.map((v) => {
              return v.medicalCountNum
            })
          )
          setErrorData(
            res.latestYearSupervise.map((v) => {
              return v.cautionNum
            })
          )
          setAreaData(
            res.subAreaCountData.map((v) => {
              return {
                name: v.areaName,
                ...v,
              }
            })
          )
        })
    }
  }, [dispatch, regionCode])

  //监管机构占比
  // useEffect(() => {
  //   if (regionCode) {
  //     dispatch(getStaticData({ ...stiatic, regionCode }))
  //       .then(unwrapResult)
  //       .then((res) => {
  //         setFirstList(
  //           res.map((v) => {
  //             return {
  //               name: v.regionName,
  //               value: v.total || undefined,
  //             };
  //           })
  //         );
  //       });
  //   }
  // }, [dispatch, stiatic, regionCode, TagData]);

  //预警占比
  useEffect(() => {
    if (regionCode) {
      dispatch(getCountyRuleUseData({ ...ruleUser, regionCode }))
        .then(unwrapResult)
        .then((res) => {
          setRuleUseData(
            res.map((v) => {
              return {
                name: v.provRuleName,
                value: v.total || undefined,
              }
            })
          )
        })
    }
    // }, [dispatch, WarningData, regionCode, areaV, ruleUser]);
  }, [dispatch, regionCode, ruleUser])

  useEffect(() => {
    if (regionCode) {
      dispatch(
        getWarningRuleAnaylseData({ ...WarningData, dType: 2, regionCode })
      )
        .then(unwrapResult)
        .then((res) => {
          setSecondList(
            res.map((v) => {
              return {
                name: v.provRuleName,
                value: v.total || undefined,
              }
            })
          )
        })
    }
    // }, [dispatch, WarningData, regionCode, areaV, ruleUser]);
  }, [WarningData, dispatch, regionCode])

  // 接入机构占比
  // useEffect(() => {
  //   if (regionCode) {
  //     dispatch(getOrganizationData({ scope: 2, regionCode }))
  //       .then(unwrapResult)
  //       .then((res) => {
  //         setGroudByList(
  //           res.map((v, i) => {
  //             return {
  //               name:
  //                 v.regionName?.endsWith("市") ||
  //                 v.regionName?.endsWith("县") ||
  //                 v.regionName?.endsWith("区")
  //                   ? v.regionName.substring(0, v.regionName.length - 1)
  //                   : v.regionName?.substr(0, 4),
  //               // value1: v.total,
  //               value1: v.total,
  //               value2: v.accessTotal,
  //             }
  //           })
  //         )
  //       })
  //   }
  // }, [dispatch, regionCode])

  useEffect(() => {
    if (cityPath.length >= 1) {
      setArea(cityPath[cityPath.length - 1].cityName)
    }
  }, [cityPath])

  const [organizationValue, setOrganizationValue] = useAnimateNumber(0, orgOp) // 机构数

  const [doctorValue, setDoctorValue] = useAnimateNumber(0, docOp) // 医生数

  const [medicalRecordValue, setMedicalRecordValue] = useAnimateNumber(0, medOp) // 诊疗数

  const [cautionValue, setCautionValue] = useAnimateNumber(0, errOp) // 预警数

  const [disposeValue, setDisposeValue] = useAnimateNumber(0, hadOp) // 执法数

  //全屏缩放
  useEffect(() => {
    const element: any = document.documentElement
    if (IsFullscreen === true) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        // 兼容火狐
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        // 兼容谷歌
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        // 兼容IE
        element.msRequestFullscreen()
      }
    } else if (IsFullscreen === false) {
      document.exitFullscreen()
      history.go(0)
      // useForceUpdate()
    }
  }, [IsFullscreen])
  const [scaledFontSize, setScaledFontSize] = useState(16.0)

  const [windowWidth] = useWindowSize()
  // 配置首页根元素字体大小

  const createStart = () => {
    var stars = document.getElementById("stars")
    // 封装随机数方法
    function randomDistance(max: any, min: any) {
      var distance = Math.floor(Math.random() * (max - min + 1) + min)
      return distance
    }
    // js随机生成流星
    for (var j = 0; j < 30; j++) {
      var newStar = document.createElement("div")
      newStar.className = "star"
      newStar.style.top = randomDistance(0, -6) + "em"
      newStar.style.left = randomDistance(70, 2) + "em"
      stars?.appendChild(newStar)
    }

    var star: any = document.getElementsByClassName("star")
    // 给流星添加动画延时
    for (var i = 0, len = star.length; i < len; i++) {
      star[i].style.animationDelay = i % 6 === 0 ? "0s" : i * 0.8 + "s"
    }
  }

  useEffect(() => {
    createStart()
  }, [])

  useEffect(() => {
    if (windowWidth > 0) {
      setScaledFontSize((windowWidth / 1920.0) * 16.0)
    }
  }, [windowWidth])

  useEffect(() => {
    return () => {
      setSecondDate({
        scope: undefined,
        ps: undefined,
      })
      setWarningData({
        text: "预警占比",
        scope: undefined,
      })
      setTable([])
      setFirstDate(null)
      setTable([])
      setCountTimeData([])
      setSecondList([])
      setRuleUseData([])
      setOrganizationValue(0, true)
      setDoctorValue(0, true)
      setMedicalRecordValue(0, true)
      setCautionValue(0, true)
      setDisposeValue(0, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionCode])

  return (
    <div
      className={styles.bg}
      style={{
        fontSize: scaledFontSize,
        height: document.body.clientHeight + "px",
      }}
    >
      <div id={styles.head}>
        <span>数据更新时间:{moment().format(DateTimeFormat)}</span>
        <p className={styles.noFlag}>诊疗行为智能监管系统</p>
        <span>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setIsFullscreen(!IsFullscreen)
            }}
          >
            {isFullscreen() ? (
              <FullscreenExitOutlined
                style={{
                  fontSize: "1em",
                  marginRight: 4,
                }}
              />
            ) : (
              <ExpandOutlined
                style={{
                  fontSize: "1em",
                  marginRight: 4,
                }}
              />
            )}
            全屏
          </span>
        </span>
      </div>
      <div className={styles.content}>
        <div className={styles.left}>
          <>
            <DataCard
              title='诊疗违法行为数据总览'
              extra={
                <Switch
                  options={["本年", "全部"]}
                  value={FirstDate ? "本年" : "全部"}
                  onChange={(t) => {
                    if (t === "本年") {
                      setFirstDate(2)
                    } else {
                      setFirstDate(null)
                    }
                  }}
                />
              }
              style={{ flex: 1 }}
            >
              <TableSimple data={Table}></TableSimple>
            </DataCard>
            <DataCard
              title='诊疗高发行为分布'
              extra={
                <>
                  <Switch
                    options={["本年", "全部"]}
                    value={SecondDate.scope ? "本年" : "全部"}
                    onChange={(t) => {
                      if (t === "本年") {
                        setSecondDate({
                          ...SecondDate,
                          scope: 2,
                        })
                      } else {
                        setSecondDate({
                          ...SecondDate,
                          scope: undefined,
                        })
                      }
                    }}
                  />
                </>
              }
              style={{ marginTop: 10 }}
            >
              <div className={styles.list}>
                {ProgressData?.map((v, i) => {
                  const max = ProgressData?.reduce((m, d) => m + d.num, 0)
                  return (
                    <Progress
                      sortStyle={{
                        color:
                          i === 0
                            ? "#FF3D00"
                            : i === 1
                            ? "#FF8800"
                            : i === 2
                            ? "#FFB300"
                            : "#00DBFE",
                      }}
                      style={{
                        background:
                          i === 0
                            ? "linear-gradient(90deg, #004CFF 0%, #FF3D00 100%)"
                            : i === 1
                            ? "linear-gradient(90deg, #004CFF 0%, #FF9900 100%)"
                            : i === 2
                            ? "linear-gradient(90deg, #004CFF 0%, #FFFF00 100%)"
                            : "linear-gradient(90deg, #004CFF 0%, #00EDFF 100%)",
                      }}
                      key={i}
                      sortNumber={i + 1}
                      name={v.ruleName}
                      value={v.num}
                      max={max}
                    />
                  )
                })}
              </div>
            </DataCard>
          </>
          {Table.length ? (
            <DataCard
              title='近一年监管变化图'
              style={{ marginTop: 10, marginBottom: 10, flex: 1 }}
            >
              <LineCharts
                handle={HandleData}
                error={ErrorData}
                style={{ height: "calc(100% - 3.5em)" }}
              ></LineCharts>
            </DataCard>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.center}>
          <div className={styles.top}>{area}</div>
          <div className={styles.middle}>
            <div className={styles.tag}>
              <DataTag
                Lable='监管医生'
                text='人'
                align='right'
                icon={
                  <Icon
                    icon='doctor'
                    mode='large'
                    style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                  />
                }
                style={{ marginBottom: "1.875em", marginTop: "2.5em" }}
              >
                {doctorValue}
                {transformNumber(TagData?.doctorTotal).unit}
              </DataTag>
              <DataTag
                Lable='监管诊疗行为'
                text='次'
                align='right'
                icon={
                  <Icon
                    icon='behavior'
                    mode='large'
                    style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                  />
                }
              >
                {medicalRecordValue}
                {transformNumber(TagData?.medicalTotal).unit}
              </DataTag>
            </div>
            <div className={styles.zs}>
              <div className={styles.animationBox}></div>
              <ul>
                <p>监管机构</p>
                <p>
                  <span
                    style={{
                      fontSize: "2em",
                      fontWeight: "bold",
                    }}
                  >
                    {organizationValue}
                    {transformNumber(TagData?.organizationTotal).unit}
                  </span>
                  &nbsp;家
                </p>
              </ul>
            </div>
            <div className={styles.tag}>
              <DataTag
                Lable='预警数'
                text='条'
                icon={
                  <Icon
                    icon='error'
                    mode='large'
                    style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                  />
                }
                style={{ marginBottom: "1.875em", marginTop: "2.5em" }}
              >
                {cautionValue}
                {transformNumber(TagData?.cautionTotal).unit}
              </DataTag>
              <DataTag
                Lable='处置数'
                text='条'
                icon={
                  <Icon
                    icon='handle'
                    mode='large'
                    style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                  />
                }
              >
                {disposeValue}
                {transformNumber(TagData?.handleTotal).unit}
              </DataTag>
            </div>
          </div>

          <div className={styles.bottom} id='stars'>
            {/* <div ></div> */}
            <MapCharts
              mapdata={areaData}
              cityCode={Number(regionCode)}
              style={{ height: "95%" }}
              onRecord={(obj: regionType) => {
                console.log(obj)
              }}
            />
          </div>
        </div>
        <div className={styles.right}>
          <DataCard
            title='平均处理时间'
            style={{ flex: 1, display: "flex", flexDirection: "column" }}
          >
            <DonutPieCharts pieData={countyTimeData} style={{ flex: 1 }} />
          </DataCard>
          <DataCard
            title='规则预警占比分析'
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              marginTop: 10,
            }}
            extra={
              <>
                <Switch
                  options={["本年", "全部"]}
                  value={WarningData.scope ? "本年" : "全部"}
                  onChange={(t) => {
                    if (t === "本年") {
                      setWarningData({
                        ...WarningData,
                        scope: 2,
                      })
                    } else {
                      setWarningData({
                        ...WarningData,
                        scope: undefined,
                      })
                    }
                  }}
                />
              </>
            }
          >
            {/* {SecondList.every((v: any) => v.value) ? ( */}
            <DonutPieCharts
              pieData={SecondList}
              style={{
                flex: 1,
                overflow: "hidden",
                height: "100%",
                paddingLeft: 16,
                paddingRight: 16,
              }}
            />
            {/* ) : (
                  <></>
                )} */}
          </DataCard>
          <DataCard
            // title="规则执法占比分析"
            title='处置占比分析'
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              marginTop: 10,
            }}
            extra={
              <>
                <Switch
                  options={["本年", "全部"]}
                  value={ruleUser.scope ? "本年" : "全部"}
                  onChange={(t) => {
                    if (t === "本年") {
                      setRuleUser({
                        ...ruleUser,
                        scope: 2,
                      })
                    } else {
                      setRuleUser({
                        ...ruleUser,
                        scope: undefined,
                      })
                    }
                  }}
                />
              </>
            }
          >
            {/* {ruleUseData.every((v: any) => v.value) ? ( */}
            <DonutPieCharts pieData={ruleUseData} style={{ flex: 1 }} />
            {/* ) : (
                  <></>
                )} */}
          </DataCard>
        </div>
      </div>
    </div>
  )
}
